//import node_modules
import React, { FunctionComponent } from "react";
import NextLink from "@adjust/website/src/components/NextLink";
import { format } from "date-fns/format";
import { Col, Button } from "react-bootstrap";

//libs
import { cx, css } from "libs/emotion";

//types
import type { BlogDocument } from "@adjust/libs/database/blogs";

type BlogPreviewProps = {
  blog: BlogDocument;
  order: number;
};

const clickableCSS = css({
  color: "black",
  textDecoration: "none",

  [":hover"]: {
    color: "black",
    textDecoration: "underline",
  },
});

const containerCSS = css({
  display: "flex",
  textAlign: "center",
  flexDirection: "column",
  fontFamily: "DM Sans, sans-serif",
  margin: "16px",
});

const InformationComponent: FunctionComponent<BlogPreviewProps> = ({ blog, order }) => {
  return (
    <Col xs={{ order: 2, span: 12 }} lg={{ order: order, span: 4 }}>
      <div className={containerCSS}>
        <NextLink href={`/blog/${blog.slug}/`}>
          <a className={cx(clickableCSS, "h2 mb-3")}>{blog.title}</a>
        </NextLink>
        <div className="h5">{format(blog.publishedTime, "PPP")}</div>
        <p className="h4">{blog.description}</p>
        <div className="my-auto" />
        <div>
          <NextLink href={`/blog/${blog.slug}/`}>
            <Button variant="outline-primary" size="lg">
              READ THE POST
            </Button>
          </NextLink>
        </div>
      </div>
    </Col>
  );
};

export default React.memo(InformationComponent);
